import { RelationshipType } from "@libs/gateways/practice/PracticeGateway.dtos.ts";

export const professionalRelationships = [
  RelationshipType.Carer,
  RelationshipType.CarerOf,
  RelationshipType.Guardian,
  RelationshipType.GuardianFor
];
export const professionalRelationshipsForOrgs = [
  RelationshipType.Carer,
  RelationshipType.Guardian
];
